import { Link } from 'react-router-dom';

const REVIEW_CARDS: Array<{
  title: string;
  purpose: string;
  to: string;
  action: string;
  emphasis?: 'primary';
}> = [
  {
    title: 'Reviewed follow-ups',
    purpose: 'Review and disposition AI-extracted follow-up suggestions. The work itself is owned and closed in Customer Workbench — a review desk, not a work tracker.',
    to: '/action-items',
    action: 'Review follow-ups',
    emphasis: 'primary',
  },
  {
    title: 'Q&A Bank review',
    purpose: 'Promote durable answers and customer objections into canonical knowledge.',
    to: '/qa-bank/review',
    action: 'Review knowledge',
  },
  {
    title: 'Plaud transcripts',
    purpose: 'Validate extracted promises, decisions, open questions, and handoff facts before promotion.',
    to: '/plaud/review',
    action: 'Review transcripts',
  },
  {
    title: 'Upload transcript',
    purpose: 'Add a transcript when automated intake missed it or a manual review source is needed.',
    to: '/transcripts/upload',
    action: 'Upload source',
  },
];

export function ReviewWorkHub(): JSX.Element {
  return (
    <div className="space-y-6">
      <header>
        <div className="text-xs font-semibold uppercase tracking-wide text-cyan-700">
          Review work
        </div>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-slate-950">
          Human Review Desk
        </h1>
        <p className="mt-1 max-w-3xl text-sm leading-6 text-slate-600">
          Promote machine-detected evidence into durable work or knowledge. This area is for
          review decisions, not customer action.
        </p>
      </header>

      <section className="grid gap-4 lg:grid-cols-2">
        {REVIEW_CARDS.map((card) => (
          <HubCard key={card.to} {...card} />
        ))}
      </section>
    </div>
  );
}

function HubCard({
  title,
  purpose,
  to,
  action,
  emphasis,
}: {
  title: string;
  purpose: string;
  to: string;
  action: string;
  emphasis?: 'primary';
}): JSX.Element {
  return (
    <article className="rounded-lg bg-white p-5 shadow-sm ring-1 ring-slate-200">
      <div className="flex h-full flex-col gap-4">
        <div>
          <h2 className="text-base font-semibold text-slate-950">{title}</h2>
          <p className="mt-1 text-sm leading-6 text-slate-600">{purpose}</p>
        </div>
        <div className="mt-auto">
          <Link
            to={to}
            className={
              emphasis === 'primary'
                ? 'inline-flex rounded-md bg-slate-900 px-3 py-2 text-sm font-medium text-white transition hover:bg-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400'
                : 'inline-flex rounded-md border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400'
            }
          >
            {action}
          </Link>
        </div>
      </div>
    </article>
  );
}
